// shared by both register and account flows
import { withNewEmergencyContactForm } from 'components/account/EmergencyContacts/New'

// presentational components specific to register flow
import UI from './UI'

// in reg flow, redirect to emergency contacts list
export default withNewEmergencyContactForm({
  onSuccess: data =>
    window.dataLayer &&
    window.dataLayer.push({ event: 'register.createEmergencyContact' }),
  redirect: '/emergency_contacts'
})(UI)
